import React from "react";
import { ENV, PROD, SUB_DIRECTORY, UAT } from "../../common/constant";


const Footer = () => {

    return (
        <>
            <>
                {/* BEGIN: FOOTER */}
                <footer>
                    <div className="bg-light">
                        <div className="container">
                            <div className="row py-4">
                                <div className="col-lg-2">
                                    <div className="border-sm-bottom">
                                        <ul className="list-unstyled my-2">
                                            <li className="cust-fs-14 text-primary d-block cursor-pointer">
                                                <a
                                                    className="text-primary fw-600 collapsed"
                                                    data-bs-toggle="collapse"
                                                    href="#QuickLinks"
                                                    aria-expanded="false"
                                                    aria-controls="QuickLinks"
                                                >
                                                    PINC
                                                    <i className="collapse-icon d-lg-none d-xl-none" />
                                                </a>
                                            </li>
                                        </ul>
                                        <div
                                            className="collapse dont-collapse-sm d-lg-block"
                                            id="QuickLinks"
                                        >
                                            <ul className="list-unstyled pb-2 footer-link cust-fs-14 footer-list mb-0">
                                                <li className="">
                                                    <a
                                                        className="nounderline text-dark"
                                                        href={`${ENV === 'development' ? UAT + 'about-pinc' : PROD + 'about-pinc'}`}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                    >
                                                        About Us
                                                    </a>
                                                </li>
                                                <li className="">
                                                    <a
                                                        className="nounderline text-dark"
                                                        href={`${ENV === 'development' ? UAT + 'blog' : PROD + 'blog'}`}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                    >
                                                        Blogs
                                                    </a>
                                                </li>
                                                <li className="">
                                                    <a

                                                        className="nounderline text-dark"
                                                        href={`${ENV === 'development' ? UAT + 'career' : PROD + 'career'}`}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                    >
                                                        Careers
                                                    </a>
                                                </li>
                                                <li className="">
                                                    <a
                                                        className="nounderline text-dark"
                                                        href={`${ENV === 'development' ? UAT + 'contact-us' : PROD + 'contact-us'}`}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                    >
                                                        Contact Us
                                                    </a>
                                                </li>
                                                <li>
                                                    <a
                                                        className="nounderline text-dark"
                                                        href={`${ENV === 'development' ? UAT + 'html-sitemap' : PROD + 'html-sitemap'}`}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                    >
                                                        Sitemap
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                        <div className="">
                                            <ul className="list-unstyled my-2">
                                                <li className="cust-fs-14 text-primary d-block cursor-pointer">
                                                    <a
                                                        className="text-primary fw-600 collapsed"
                                                        data-bs-toggle="collapse"
                                                        href="#ImpLinks"
                                                        aria-expanded="false"
                                                        aria-controls="ImpLinks"
                                                    >
                                                        Important Links
                                                        <i className="collapse-icon d-lg-none d-xl-none" />
                                                    </a>
                                                </li>
                                            </ul>
                                            <div
                                                className="collapse dont-collapse-sm d-lg-block"
                                                id="ImpLinks"
                                            >
                                                <ul className="list-unstyled pb-2 footer-link cust-fs-14 footer-list mb-0">
                                                    <li className="">
                                                        <a
                                                            href="https://www.irdai.gov.in/"
                                                            className="nounderline text-dark"
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                        >
                                                            IRDAI
                                                        </a>
                                                    </li>
                                                    <li className="">
                                                        <a
                                                            href="https://ibai.org/"
                                                            className="nounderline text-dark"
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                        >
                                                            IBAI
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-2">
                                    <div className="border-sm-bottom">
                                        <ul className="list-unstyled my-2">
                                            <li className="cust-fs-14 text-primary d-block cursor-pointer">
                                                <a
                                                    className="text-primary fw-600 collapsed"
                                                    data-bs-toggle="collapse"
                                                    href="#retailInsurance"
                                                    aria-expanded="false"
                                                    aria-controls="retailInsurance"
                                                >
                                                    Retail Insurance
                                                    <i className="collapse-icon d-lg-none d-xl-none" />
                                                </a>
                                            </li>
                                        </ul>
                                        <div
                                            className="collapse dont-collapse-sm d-lg-block"
                                            id="retailInsurance"
                                        >
                                            <ul className="list-unstyled pb-2 footer-link cust-fs-14 mb-0">
                                                <li>
                                                    <a
                                                        className="nounderline text-dark"
                                                        href={`${ENV === 'development' ? 'https://www.staypinc.com' : 'https://www.pincinsurance.com'}`}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                    >
                                                        Overview
                                                    </a>
                                                </li>
                                                <li>
                                                    <a
                                                        className="nounderline text-dark"
                                                        href={`${ENV === 'development' ? UAT + 'car-insurance' : PROD + 'car-insurance'}`}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                    >
                                                        Car
                                                    </a>
                                                </li>
                                                <li>
                                                    <a
                                                        className="nounderline text-dark"
                                                        href={`${ENV === 'development' ? UAT + 'bike-insurance' : PROD + 'bike-insurance'}`}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                    >
                                                        Bike
                                                    </a>
                                                </li>
                                                <li>
                                                    <a
                                                        className="nounderline text-dark"
                                                        href={`${ENV === 'development' ? UAT + 'health-insurance' : PROD + 'health-insurance'}`}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                    >
                                                        Health
                                                    </a>
                                                </li>
                                                <li>
                                                    <a
                                                        className="nounderline text-dark"
                                                        href={`${ENV === 'development' ? UAT + 'travel' : PROD + 'travel'}`}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                    >
                                                        Travel
                                                    </a>
                                                </li>
                                                <li>
                                                    <a
                                                        className="nounderline text-dark"
                                                        href={`${ENV === 'development' ? UAT + 'cyber-insurance' : PROD + 'cyber-insurance'}`}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                    >
                                                        Cyber
                                                    </a>
                                                </li>
                                                <li>
                                                    <a
                                                        className="nounderline text-dark"
                                                        href={`${ENV === 'development' ? UAT + 'term-insurance' : PROD + 'term-insurance'}`}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                    >
                                                        Term Life
                                                    </a>
                                                </li>
                                                <li>
                                                    <a
                                                        className="nounderline text-dark"
                                                        href={`${ENV === 'development' ? UAT + 'claim' : PROD + 'claim'}`}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                    >
                                                        Claims
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-3">
                                    <div className="border-sm-bottom">
                                        <ul className="list-unstyled my-2">
                                            <li className="cust-fs-14 text-primary d-block cursor-pointer">
                                                <a
                                                    className="text-primary fw-600 collapsed"
                                                    data-bs-toggle="collapse"
                                                    href="#corporateInsurance"
                                                    aria-expanded="false"
                                                    aria-controls="corporateInsurance"
                                                >
                                                    Corporate Insurance
                                                    <i className="collapse-icon d-lg-none d-xl-none" />
                                                </a>
                                            </li>
                                        </ul>
                                        <div
                                            className="collapse dont-collapse-sm d-lg-block"
                                            id="corporateInsurance"
                                        >
                                            <ul className="list-unstyled pb-2 footer-link cust-fs-14 mb-0">
                                                <li className="text-dark">
                                                    <a
                                                        className="nounderline text-dark"
                                                        href={`${ENV === 'development' ? UAT + 'corporate-insurance' : PROD + 'corporate-insurance'}`}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                    >
                                                        Overview
                                                    </a>
                                                </li>
                                                <li className="text-dark">
                                                    <a
                                                        href={`${ENV === 'development' ? UAT + 'corporate-insurance/group-health-insurance-for-employee' : PROD + 'corporate-insurance/group-health-insurance-for-employee'}`}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        className="nounderline text-dark"
                                                    >
                                                        Employee Benefit
                                                    </a>
                                                </li>
                                                <li className="text-dark">
                                                    <a
                                                        className="nounderline text-dark"
                                                        href={`${ENV === 'development' ? UAT + 'corporate-insurance/property-and-engineering-insurance-policy' : PROD + 'corporate-insurance/property-and-engineering-insurance-policy'}`}
                                                        target="_blank"
                                                        rel="noopener noreferrer"

                                                    >
                                                        Property and Engineering
                                                    </a>
                                                </li>
                                                <li className="text-dark">
                                                    <a
                                                        className="nounderline text-dark"
                                                        href={`${ENV === 'development' ? UAT + 'corporate-insurance/liability-insurance-policy' : PROD + 'corporate-insurance/liability-insurance-policy'}`}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                    >
                                                        Liability
                                                    </a>
                                                </li>
                                                <li className="text-dark">
                                                    <a
                                                        className="nounderline text-dark"
                                                        href={`${ENV === 'development' ? UAT + 'corporate-insurance/motor-fleet-insurance-policy' : PROD + 'corporate-insurance/motor-fleet-insurance-policy'}`}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                    >
                                                        Motor Fleet
                                                    </a>
                                                </li>
                                                <li className="text-dark">
                                                    <a
                                                        className="nounderline text-dark"
                                                        href={`${ENV === 'development' ? UAT + 'corporate-insurance/transit-insurance-policy' : PROD + 'corporate-insurance/transit-insurance-policy'}`}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                    >
                                                        Transit
                                                    </a>
                                                </li>
                                                <li className="text-dark">
                                                    <a
                                                        className="nounderline text-dark"
                                                        href={`${ENV === 'development' ? UAT + 'ccorporate-insurance/cyber-insurance-policy' : PROD + 'corporate-insurance/cyber-insurance-policy'}`}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                    >
                                                        Cyber
                                                    </a>
                                                </li>
                                                <li className="text-dark">
                                                    <a
                                                        className="nounderline text-dark"
                                                        href={`${ENV === 'development' ? UAT + 'corporate-insurance/credit-insurance-policy' : PROD + 'corporate-insurance/credit-insurance-policy'}`}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                    >
                                                        Credit
                                                    </a>
                                                </li>
                                                <li className="text-dark">
                                                    <a
                                                        className="nounderline text-dark"
                                                        href={`${ENV === 'development' ? UAT + 'corporate-insurance/office-package-insurance-policy' : PROD + 'corporate-insurance/office-package-insurance-policy'}`}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                    >
                                                        Office Package
                                                    </a>
                                                </li>
                                                <li className="text-dark">
                                                    <a
                                                        className="nounderline text-dark"
                                                        href={`${ENV === 'development' ? UAT + 'corporate-insurance/shop-insurance-policy' : PROD + 'corporate-insurance/shop-insurance-policy'}`}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                    >
                                                        Shopkeepers Package
                                                    </a>
                                                </li>
                                                <li className="text-dark">
                                                    <a
                                                        className="nounderline text-dark"
                                                        href={`${ENV === 'development' ? UAT + 'corporate-insurance/group-travel-insurance-policy' : PROD + 'corporate-insurance/group-travel-insurance-policy'}`}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                    >
                                                        Group Travel
                                                    </a>
                                                </li>
                                                <li className="text-dark">
                                                    <a
                                                        className="nounderline text-dark"
                                                        href={`${ENV === 'development' ? UAT + 'corporate-insurance/risk-management-insurance-consulting' : PROD + 'corporate-insurance/risk-management-insurance-consulting'}`}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                    >
                                                        Risk Management
                                                    </a>
                                                </li>
                                                <li className="text-dark">
                                                    <a
                                                        className="nounderline text-dark"
                                                        href={`${ENV === 'development' ? UAT + 'corporate-insurance/insurance-claim-management' : PROD + 'corporate-insurance/insurance-claim-management'}`}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                    >
                                                        Claim Management
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-3">
                                    <div className="border-sm-bottom">
                                        <ul className="list-unstyled my-2">
                                            <li className="cust-fs-14 text-primary d-block cursor-pointer">
                                                <a
                                                    className="text-primary fw-600 collapsed"
                                                    data-bs-toggle="collapse"
                                                    href="#reinsurance"
                                                    aria-expanded="false"
                                                    aria-controls="reinsurance"
                                                >
                                                    Reinsurance
                                                    <i className="collapse-icon d-lg-none d-xl-none" />
                                                </a>
                                            </li>
                                        </ul>
                                        <div
                                            className="collapse dont-collapse-sm d-lg-block"
                                            id="reinsurance"
                                        >
                                            <ul className="list-unstyled pb-2 footer-link cust-fs-14 mb-0">
                                                <li className="text-dark">
                                                    <a
                                                        className="nounderline text-dark"
                                                        href={`${ENV === 'development' ? UAT + 'reinsurance' : PROD + 'reinsurance'}`}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                    >
                                                        Overview
                                                    </a>
                                                </li>
                                                <li className="text-dark">
                                                    <a
                                                        className="nounderline text-dark"
                                                        href={`${ENV === 'development' ? UAT + 'reinsurance/oil-and-gas-insurance' : PROD + 'reinsurance/oil-and-gas-insurance'}`}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                    >
                                                        Energy
                                                    </a>
                                                </li>
                                                <li className="text-dark">
                                                    <a
                                                        className="nounderline text-dark"
                                                        href={`${ENV === 'development' ? UAT + 'reinsurance/marine-hull-insurance' : PROD + 'reinsurance/marine-hull-insurance'}`}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                    >
                                                        Marine Hull &amp; Cargo
                                                    </a>
                                                </li>
                                                <li className="text-dark">
                                                    <a
                                                        className="nounderline text-dark"
                                                        href={`${ENV === 'development' ? UAT + 'reinsurance/property-and-engineering' : PROD + 'reinsurance/property-and-engineering'}`}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                    >
                                                        Property &amp; Engineering
                                                    </a>
                                                </li>
                                                <li className="text-dark">
                                                    <a
                                                        className="nounderline text-dark"
                                                        href={`${ENV === 'development' ? UAT + 'reinsurance/specie-and-fine-arts-insurance' : PROD + 'reinsurance/specie-and-fine-arts-insurance'}`}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                    >
                                                        Specie &amp; Fine Arts
                                                    </a>
                                                </li>
                                                <li className="text-dark">
                                                    <a
                                                        className="nounderline text-dark"
                                                        href={`${ENV === 'development' ? UAT + 'reinsurance/aviation-insurance' : PROD + 'reinsurance/aviation-insurance'}`}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                    >
                                                        Aviation
                                                    </a>
                                                </li>
                                                <li className="text-dark">
                                                    <a
                                                        className="nounderline text-dark"
                                                        href={`${ENV === 'development' ? UAT + 'reinsurance/political-risk-and-terrorism-insurance' : PROD + 'reinsurance/political-risk-and-terrorism-insurance'}`}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                    >
                                                        Political Risk &amp; Terrorism
                                                    </a>
                                                </li>
                                                <li className="text-dark">
                                                    <a
                                                        className="nounderline text-dark"
                                                        href={`${ENV === 'development' ? UAT + 'reinsurance/financial-and-casualty-lines' : PROD + 'reinsurance/financial-and-casualty-lines'}`}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                    >
                                                        Financial &amp; Casualty Lines
                                                    </a>
                                                </li>
                                                <li className="text-dark">
                                                    <a
                                                        className="nounderline text-dark"
                                                        href={`${ENV === 'development' ? UAT + 'reinsurance/reinsurance-treaty' : PROD + 'reinsurance/reinsurance-treaty'}`}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                    >
                                                        Reinsurance Treaty
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-2">
                                    <div className="my-4 my-lg-2">
                                        <ul className="list-unstyled">
                                            <li>
                                                <a className=""
                                                    href={`${ENV === 'development' ? 'https://www.staypinc.com' : 'https://www.pincinsurance.com'}`}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    <img
                                                        alt="logo"
                                                        className="w-156"
                                                        src={`${SUB_DIRECTORY}/assets/images/pinclogo.jpg`}
                                                        title=""
                                                    />
                                                </a>
                                            </li>
                                            <li className="mt-4">
                                                <a>
                                                    <img
                                                        alt="logo"
                                                        className="w-4em"
                                                        src={`${SUB_DIRECTORY}/assets/images/irda.jpg`}
                                                        title=""
                                                    />
                                                </a>
                                            </li>
                                            <li className="mt-4">
                                                <a className="">
                                                    <img
                                                        alt="logo"
                                                        className="w-156"
                                                        src={`${SUB_DIRECTORY}/assets/images/lloyds.png`}
                                                        title=""
                                                    />
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="row text-dark">
                                <div className="col-12 text-center">
                                    <div className="mb-2">
                                        <a
                                            className="mr-2"
                                            href="https://www.facebook.com/PINCInsurance/"
                                            aria-label="Facebook"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            <i className="fa fa-facebook-official text-dark fa-lg" />
                                        </a>
                                        <a
                                            className="mr-2"
                                            href="https://linkedin.com/company/pincinsure"
                                            aria-label="Linkedin"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            style={{
                                                marginLeft: '6px',
                                            }}
                                        >
                                            <i className="fa fa-linkedin-square text-dark fa-lg" />
                                        </a>
                                        <a
                                            className="mr-2"
                                            href="https://www.instagram.com/pinc_insurance/"
                                            aria-label="Instagram"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            style={{
                                                marginLeft: '6px',
                                            }}
                                        >
                                            <i className="fa fa-instagram text-dark fa-lg" />
                                        </a>
                                        <a
                                            className="mr-2"
                                            href=" https://twitter.com/PINCInsurance"
                                            aria-label="Twitter"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            style={{
                                                marginLeft: '6px',
                                            }}
                                        >
                                            <i className="fa fa-twitter-square text-dark fa-lg" />
                                        </a>
                                    </div>
                                </div>
                                <div className="col-12 text-center border-top py-2">
                                    <p className="text-dark fs-7 mt-1 mb-0">
                                        <span className="text-primary fw-bold">
                                            Pioneer Insurance &amp; Reinsurance Brokers Pvt. Ltd. :
                                        </span>
                                        1219, 12th floor, Maker Chamber 5, Jamnalal Bajaj Rd, Nariman
                                        Point, Mumbai, Maharashtra 400021
                                    </p>
                                    <p className="text-dark fs-7 mt-1">
                                        CIN No.: U67200MH2002PTC137896 | IRDAI License No.: 118 |
                                        Validity: 24.02.2021 – 23.02.2024 | Category: Composite Brokers
                                    </p>
                                    <span className="text-dark fs-7">
                                        <i className="fa fa-copyright" /> All Rights Reserved. Copyright
                                        2021 Pioneer Insurance &amp; Reinsurance Brokers Pvt. Ltd.
                                    </span>
                                    <div className="text-center">
                                        <ul className="list-inline fs-7">
                                            <li className="list-inline-item mr-0">
                                                <a
                                                    className="text-dark"
                                                    href='https://cdn.pincinsurance.com/document/Certificate_of_Renewal_of_Registration_24.02.2021-23.02.2024.pdf'
                                                    title=""
                                                    target="_blank"
                                                    rel="noopener noreferrer"

                                                >
                                                    License
                                                </a>&nbsp;&nbsp;
                                                <span>|</span>
                                            </li>
                                            <li className="list-inline-item mr-0">
                                                <a
                                                    className="text-dark"
                                                    href='https://cdn.pincinsurance.com/document/disclaimer.pdf'
                                                    title=""
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    Disclaimer
                                                </a>&nbsp;&nbsp;
                                                <span>|</span>
                                            </li>
                                            <li className="list-inline-item mr-0">
                                                <a
                                                    className="text-dark"
                                                    href='https://cdn.pincinsurance.com/document/termsofuse.pdf'
                                                    title=""
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    Terms of Use
                                                </a>&nbsp;&nbsp;
                                                <span>|</span>
                                            </li>
                                            <li className="list-inline-item mr-0">
                                                <a
                                                    className="text-dark"
                                                    href={`${ENV === 'development' ? UAT + 'privacy-document' : PROD + 'privacy-document'}`}
                                                    title=""
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    Privacy Policy
                                                </a>&nbsp;&nbsp;
                                                <span>|</span>
                                            </li>
                                            <li className="list-inline-item mr-0">
                                                <a
                                                    className="text-dark"
                                                    href={`${ENV === 'development' ? UAT + 'isnp' : PROD + 'isnp'}`}
                                                    title=""
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    ISNP
                                                </a>&nbsp;&nbsp;
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </footer>
                {/* END: FOOTER */}
            </>

        </>
    )

}

export default Footer;